import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { WhoAmIService } from '../services/whoami.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TermsAcceptanceGuard {
  private whoami = inject(WhoAmIService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const user = this.whoami.user();

    if (!user) {
      // If no user, let AuthGuard handle it
      return true;
    }

    // Check if user has accepted terms at the current version
    const currentTermsVersion = environment.termsVersion;
    const currentPrivacyVersion = environment.privacyVersion;

    const hasAcceptedTerms =
      // ConsentPreferences format (signup / email-password activation)
      (user.consents?.termsAndConditionsAndPrivacyPolicy === true && user.consents?.unfairTermsAndConditions === true) ||
      // ConsentRecord format stored by OAuthCallback (termsVersion + privacyVersion)
      (user.consents?.termsVersion != null && user.consents?.privacyVersion != null) ||
      // Legacy nested format — also check version match
      (user.consents?.terms?.accepted === true && user.consents?.terms?.version === currentTermsVersion &&
       user.consents?.privacy?.accepted === true && user.consents?.privacy?.version === currentPrivacyVersion);

    if (hasAcceptedTerms) {
      return true;
    } else {
      // Redirect to terms acceptance page, preserving the intended destination
      return this.router.createUrlTree(['/accept-terms'], {
        queryParams: {
          returnUrl: state.url,
        },
      });
    }
  }
}
